<template>
  <div class="echart">
    <WaterEchart ref="refEchart" class="echart__content" :data="proportionData" :flag="888" />
    <img :src="useLevel(1)" />
    <p>风险等级</p>
  </div>
</template>
<script>
import WaterEchart from "@/components/waterEchart";
export default {
  name: "flowPoolEchart",
  props: {
    info: {
      type: Object,
      default:() => {}
    }
  },
  components: {
    WaterEchart
  },
  data () {
    return {

    }
  },
  computed: {
    // 使用比例
    proportionData: () => {
      const total = info.allUsageFlow / info.totalFlow;
      return total.toFixed(1);
    }
  },
  watch: {
    proportionData: (val) => {
      console.log(val);
      this.initEchart();
    }
  },
  mounted () {
    setTimeout(() => {
      this.initEchart();
    },400)
  },
  methods: {
    useLevel (riskLevel) {
      return require(`@/assets/images/home/risk${riskLevel}.png`);
    },
    // 初始化echart
    initEchart () {
      this.$refs.refEchart.setOptions(this.proportionData,888);
    }
  }
}
</script>
<style lang="scss" scoped>
.echart{
  width: 40%;
  height: calc(100% - 40px);
  text-align: center;
  font-size: 14px;
  box-sizing: border-box;
  >img{
    width: 30px;
    margin: 10px 0;
  }
  .echart__content{
    width: 94%;
    height: 180px;
    margin: 0 4px;
  }
}
</style>